<app-nav-header></app-nav-header>
<app-sidebar-menu></app-sidebar-menu>

<div class="page-content-wrapper">
  <div class="page-content">
    <app-chart-runs-by-hour></app-chart-runs-by-hour>
  </div>
</div>
